import { useTranslation }    from "react-i18next";
import Typography            from "_components/atoms/typography";
import { EmptyFeedIconLite } from "_assets/index";
import useStyles             from "_styles/atoms/emptyView";

const component = ( { customMsg, text, isFromUserProfile, styleProp } ) => {
	const classes = useStyles ();
	const { t }   = useTranslation ();
	const title   = customMsg || ( text || isFromUserProfile ? t ( "empty_feed" ) : t ( "empty_feed_false" ) );

	return (
		<div className = { classes.emptyContainer }>
			<div className = { classes.textContainer }>
				<EmptyFeedIconLite
					className = { classes.iconStyle }
					style     = { styleProp }
				/>

				<Typography
					className = { classes.textStyles }
					title     = { title }
					variant   = "h4"
				/>
			</div>
		</div>
	);
};

export default component;
